module.exports = __webpack_public_path__ + "img/ios-battery-charging.2608b148.svg";